import { render } from "./OverviewStatus.vue?vue&type=template&id=08acc3b6&scoped=true"
import script from "./OverviewStatus.vue?vue&type=script&lang=js"
export * from "./OverviewStatus.vue?vue&type=script&lang=js"

import "./OverviewStatus.vue?vue&type=style&index=0&id=08acc3b6&scoped=true&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08acc3b6"]])

export default __exports__